<template>
    <div class="w-full h-auto relative">
        <img src="../../assets/img/Mobile/back2.webp" alt="" class="w-full h-auto">
        <div class="absolute w-full h-[30vw] bg-gradient-to-b from-[#171717] to-transparent top-0"></div>
        <div class="flex flex-col items-start absolute top-[2vw] left-[2.5vw] text-start">
            <p class="text-gradient leading-[13vw] font-emeritus text-[12.27vw]">TOP IDLE</p>
            <p class="text-gradient leading-[13vw] font-emeritus text-[12.27vw]">POWER</p>
            <p class="text-white w-[95vw] text-start font-league font-medium text-[4.65vw] tracking-tighter leading-[5vw] mt-[4vw]">
                Ancient forces awaken! These legendary idle
                <br/>
                powers channel pure energy to grow your empire
                <br/>
                while you rest.
            </p>
            <p class="text-white w-[95vw] text-start font-league font-normal text-[3.25vw] mt-[4vw]">
                Unlock powerful passive abilities that keep working even when you're 
                <br/>
                offline. Boost your progress without lifting a finger!
            </p>
            <img src="../../assets/img/Mobile/EnterAerthospng.webp" alt="" class="w-[33.3vw] mt-[4vw]" @click="openWebLink('https://play.idle-glory.io/')">
        </div>
        <div class="absolute w-full h-auto bottom-0">
            <img src="../../assets/img/Mobile/thanh_ngang.webp" alt="" class="w-full">
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.text-gradient {
  background: linear-gradient(to bottom, 
    #FDFDFA 0%,  
    #FDFDFA 41%, 
    #FFD446 55%, 
    #FFF2B7 100%   
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>